export enum EquipmentClass {
    // Icon
    Other = 0, // circle
    Camera = 1, // video
    IOModule = 2, // bolt
    Speaker = 3, // bullhorn
    Microphone = 4, // microphone
    Siren = 5, // bullhorn
    Flashlight = 6, // shower
    Computer = 7, // hdd-o
    UPS = 8, // plug
    ConnectionBox = 9, // server
    Sign = 10, // map-signs
    Mount = 11, // long-arrow-up
    Cable = 12, // link
    NetworkAppliance = 13, // server
    InformationMaterial = 14, // file-text-alt
    Monitor = 15, // desktop
    Lighting = 16, // shower
    ComputerComponent = 17, // server
    CommunicationComponent = 18, // podcast
    CameraAccessories = 19, // plus
    CameraExtensionModule = 20, // bolt
    VideoConverter = 21, // server
    AnalogCamera = 22, // camera-retro
    DummyCamera = 23, // square
    DummySiren = 24, // square
    DummySpeaker = 25, // square
    SimCard = 26, // square
    Antenna = 27, // podcast
    GenericOutput = 28, // bullseye
    NetworkVideoRecorder = 29, // server
    DigitalVideoRecorder = 30, // server
}
